import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import { Asset } from "../../../Interfaces/Assets/Asset";
import { AssetHelper } from "../../../Lib/Helper/AssetHelper";
import Swiper from 'swiper';

export class RentalDetailLightbox {
    private photoSwipe: PhotoSwipe<PhotoSwipe.Options> = null;
    private swiperAssets: PhotoSwipe.Item[];

    constructor(private _assetHelper = new AssetHelper()) { }

    init(assetList: Asset[]): void {
        const swiper = new Swiper('.swiper', {
            direction: 'horizontal',
            loop: false,
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 8,
        });

        this.swiperAssets = this._assetHelper.GetPhotoSwipeItems(assetList);

        $('.retail_detail__asset-main').click(x => {
            let src = x.target.getAttribute('src');
            this.initLightBox(src);
        });

        $('.rental_detail__asset-list-item').click(x => {
            this.activateImage(x.target);
        });
    }

    activateImage(e: HTMLElement) {
        let index = parseInt(e.getAttribute('data-index'));

        $('.retail_detail__asset-main').attr('data-index', index);
        $('.retail_detail__asset-main').attr('src', $(e).attr('data-src'));
    }

    initLightBox(src) {
        let swiperAssets: PhotoSwipe.Item[] = [];
        let count = 0;
        let index = 0;

        for (let image of $(`.rental_detail__asset-list-item`).not('.d-none')) {
            let imageSrc = $(image).attr('data-src');
            let tmp = this.swiperAssets.find(x => x.src == imageSrc);
            swiperAssets.push(tmp);

            if (imageSrc == src) {
                index = count;
            }
            count++;
        }

        if (swiperAssets.length > 0) {
            let swipeElem = document.querySelectorAll('.pswp')[0] as HTMLElement;
            this.photoSwipe = new PhotoSwipe<PhotoSwipeUI_Default.Options>(swipeElem, PhotoSwipeUI_Default, swiperAssets, {
                index: index,
                closeEl: true,
                captionEl: false,
                fullscreenEl: false,
                zoomEl: false,
                shareEl: false,
                counterEl: false,
                arrowEl: false,
                preloaderEl: true,
                bgOpacity: 0.85,
                history: false
            });
            this.photoSwipe.init();
        }
    }
}